module.exports = __webpack_public_path__ + "static/media/music.af4adee9.svg";